<template lang='pug' src='./navigation.pug'></template>

<script>
import Icon from 'components/icon/icon'
import FormSignUp from 'components/form/form-sign-up/form-sign-up'

export default {
  computed: {
    props () {
      return this.$store.state.app.nav
    },
    links () {
      return this.$router.options.routes
    }
  },
  data () {
    return {
      scrolled: false
    }
  },
  methods: {
    active ({ going, direction }) {
      if (going === 'out' && direction === 'top') {
        this.scrolled = true
      }
      if (going === 'in' && direction === 'bottom') {
        this.scrolled = false
      }
    }
  },
  components: {
    Icon,
    FormSignUp
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/navigation.vue